import React from 'react';
import Border from '../common/border';
import ActivityTitle from '../common/ActivityTitle';
import { Activity } from '@/types/stayExperienceCardTypes';
import Icon from './Icon';

interface ActivitiesAndAmenitiesProps {
  activities?: Activity[]; // Made optional
  description: string;
}

const ActivitiesAndAmenities: React.FC<ActivitiesAndAmenitiesProps> = ({
  activities = [],
  description,
}) => {
  if (activities.length === 0) {
    return null;
  }

  return (
    <div className='mt-8'>
      <ActivityTitle title='Activities (In & Around)' className='' />
      <p className='md:text-sm text-xs leading-6 mb-9 text-justify'>
        {description}
      </p>

      <div className='grid xl:grid-cols-4 lg:grid-cols-3 xs:grid-cols-2 grid-cols-2 gap-4 mb-8 pt-2 max-w-2xl'>
        {activities.map((detail, index) => {
          const images = Array.isArray(detail.media)
            ? detail.media
                .filter(item => item?.format === 'image' && item?.url)
                .map(item => item.url)
                .filter(Boolean)
            : [];

          // isIncluded is true when not chargeable (free), false when chargeable
          const isIncluded = !detail.isChargable;

          // Format duration if available
          const duration =
            typeof detail.time === 'number' ? detail.time : undefined;

          // Format location if available
          const location = detail.locations
            ? {
                name: detail.locations.name,
                city: detail.locations.city,
                state: detail.locations.state,
              }
            : undefined;

          return (
            <Icon
              label={detail.title}
              images={images}
              description={detail.description}
              isIncluded={isIncluded}
              startTime={detail.startTime}
              endTime={detail.endTime}
              duration={duration}
              price={detail.payAtSiteCost}
              currency={detail.currency}
              currencySymbol={detail.currencySymbol}
              location={location}
              enableFullscreen={false}
              key={`activity-${index}`}
            />
          );
        })}
      </div>

      <Border />
    </div>
  );
};

export default ActivitiesAndAmenities;
